import { useEffect, useState } from "react";
import { Container, Stack, Box, Typography, Grid, Card, Avatar, Chip } from '@mui/material';
import OpenRendiciones from "./OpenRendiciones";
import moment from "moment";

//CUSTOM IMPORTS
import { getData } from "../../../../services/library";
import { logEventos } from "../../../../services/services";
import Navbar from "../../../Navbar";
import Barra from "../Barra";

export default function RepartosFinalizados() {
    const [sucursales, setSucursales] = useState([]);
    const [sucursalSelected, setsucursalSelected] = useState("");
    const [openRendiciones, setopenRendiciones] = useState(false);
    const [mostrarFicha, setmostrarFicha] = useState(true);
    const [fecha, setFecha] = useState(moment(new Date()).format("YYYY-MM-DD"));

    const getPlantas = () => {
        getData('/sucursales/tipoPlanta', setSucursales)
    };

    const abrirRendiciones = (id) => {
        setsucursalSelected(id); // Actualiza el estado
        setopenRendiciones(true);
        setmostrarFicha(false);
    };

    useEffect(() => {
        getPlantas()
    }, []);

    const handleVolver = () => {
        setmostrarFicha(true)
        setopenRendiciones(false)
        setFecha(moment(new Date()).format("YYYY-MM-DD"))
    };


    const handleChangeMas = () => {
        setFecha(moment(fecha).add(1, 'days').format("YYYY-MM-DD"));
    };
    const handleChangeMenos = () => {
        setFecha(moment(fecha).subtract(1, 'days').format("YYYY-MM-DD"));
    };

    const handleChangeHoy = () => {
        setFecha(moment(Date()).format("YYYY-MM-DD"));
    };
    useEffect(() => {
        logEventos(
            "acceso al menú Resumen de operaciones",
            "Granel",
            "Listado de repartos finalizados",
            localStorage.getItem("user"));
    }, []);


    return (
        <div>
            <Navbar />
            <Container maxWidth="xl" mt={1}>
                <Barra fecha={fecha} handleChangeMenos={handleChangeMenos} handleChangeHoy={handleChangeHoy} handleChangeMas={handleChangeMas} setFecha={setFecha} navegar={!mostrarFicha && openRendiciones} handleVolver={handleVolver} />
                <Grid container spacing={1} mt={1}>
                    {!openRendiciones && mostrarFicha && sucursales ?
                        sucursales.map(elemento =>
                            <Grid item xs={6} sm={6} md={4} key={elemento.id}>
                                <Card
                                    variant="outlined"
                                    onClick={() => abrirRendiciones(elemento.id)}
                                    sx={{ p: 1, borderRadius: 3, boxShadow: 3, cursor: 'pointer', borderColor: elemento.color_id }} >
                                    <Stack direction="row" alignItems="center" spacing={2}>
                                        {/* <CardHeader
                                            avatar={<Stack>
                                                <Avatar sx={{ bgcolor: elemento.color_id }} aria-label="recipe">
                                                    {elemento.avatar}
                                                </Avatar>
                                            </Stack>
                                            }
                                            titleTypographyProps={{ variant: 'h5' }}
                                            title={`${elemento.nombre}`}
                                        /> */}
                                        <Avatar
                                            sx={{
                                                bgcolor: elemento.color_id,
                                                width: 56,
                                                height: 56,
                                                fontSize: '18px',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            {elemento.avatar}
                                        </Avatar>
                                        <Box sx={{ flex: 1 }}>
                                            <Typography variant="h6" sx={{ fontWeight: 'bold', lineHeight: 1 }}>
                                                {elemento.nombre }
                                            </Typography>

                                        </Box>
                                    </Stack>
                                </Card>
                            </Grid>
                        )
                        : null
                    }
                </Grid>
                {openRendiciones &&
                    <OpenRendiciones
                        sucursalSelected={sucursalSelected}
                        setopen={setopenRendiciones}
                        open={openRendiciones}
                        fecha={fecha}
                        setFecha={setFecha}
                    />}
            </Container>
        </div>
    )
}